export default function notObjectError() {
  throw new Error('first argument must be an object')
}
